/* Stone colours + paint mode for the 3D studios. Loads ff-stonereport.js and ff-stonestage.js. */
(function () {
"use strict";
if (window.FFPaint || !window.THREE) return;
var SELF = document.currentScript && document.currentScript.src;
var anchor = document.getElementById("optMetal") || document.getElementById("optStone");
var cta = document.getElementById("cta"), cvs = document.getElementById("gl");
if (!anchor || !cta || !cvs) return;
var GRILLZ = !!document.getElementById("optMetal");

var PICKS = [["#FFFFFF", "Clear"], ["#FF7DB0", "Pink"], ["#FFD23F", "Canary"], ["#3E8BFF", "Blue"],
["#2FBF71", "Green"], ["#E5322D", "Red"], ["#8A4BE0", "Purple"], ["#1A1A1D", "Black"]];
var NAMES = [["Red", 0], ["Orange", 28], ["Canary", 50], ["Lime", 85], ["Green", 135], ["Teal", 170], ["Aqua", 190],
["Blue", 220], ["Indigo", 250], ["Purple", 275], ["Magenta", 300], ["Pink", 330], ["Red", 360]];
function hsvHex(h, s, v) {
var f = function (n) { var k = (n + h / 60) % 6; return v - v * s * Math.max(0, Math.min(k, 4 - k, 1)); };
return ("#" + [f(5), f(3), f(1)].map(function (x) { var t = Math.round(x * 255).toString(16); return t.length < 2 ? "0" + t : t; }).join("")).toUpperCase();
}
function hexHsv(hex) {
var r = parseInt(hex.substr(1, 2), 16) / 255, g = parseInt(hex.substr(3, 2), 16) / 255, b = parseInt(hex.substr(5, 2), 16) / 255;
var mx = Math.max(r, g, b), d = mx - Math.min(r, g, b), h = 0;
if (d) { h = mx === r ? ((g - b) / d) % 6 : mx === g ? (b - r) / d + 2 : (r - g) / d + 4; h *= 60; if (h < 0) h += 360; }
return [h, mx ? d / mx : 0, mx];
}
function isClear(hex) { if (!hex) return true; var v = hexHsv(hex); return v[1] < 0.06 && v[2] > 0.9; }
function shadeName(hex) {
if (isClear(hex)) return "Clear";
var hsv = hexHsv(hex);
if (hsv[2] < 0.22) return "Black";
if (hsv[1] < 0.12) return "Grey";
var best = NAMES[0], bd = 999;
NAMES.forEach(function (n) { var d = Math.abs(n[1] - hsv[0]); if (d < bd) { bd = d; best = n; } });
return (hsv[2] < 0.55 ? "Deep " : hsv[1] < 0.45 ? "Pale " : "") + best[0];
}

/* ---- capture the renderer, scene, camera and stone meshes as they draw ---- */
var R = null, S = null, C = null, base = null, brush = "#FFFFFF", meshes = [], cols = {};
function colOf(hex) { return cols[hex] || (cols[hex] = new THREE.Color().set(hex).convertSRGBToLinear()); }
var IM = THREE.InstancedMesh.prototype, origSet = IM.setColorAt, prevHook = IM.onBeforeRender, _c = new THREE.Color(), WHITE = new THREE.Color(1, 1, 1);
IM.setColorAt = function (i, c) {
var p = this.__ffp, hx = p && (p[i] || base);
if (hx && !isClear(hx)) return origSet.call(this, i, _c.copy(c).multiply(colOf(hx)));
return origSet.call(this, i, c);
};
IM.onBeforeRender = function (r, s, c) {
R = r; S = s; C = c;
if (!this.__ffp) { this.__ffp = new Array(this.count); meshes.push(this); repaint(this); }
if (prevHook) return prevHook.apply(this, arguments);
};
function live() { meshes = meshes.filter(function (m) { return m.parent; }); return meshes; }
function repaint(m) { for (var i = 0; i < m.count; i++) m.setColorAt(i, WHITE); if (m.instanceColor) m.instanceColor.needsUpdate = true; changed(); }
function repaintAll() { live().forEach(repaint); }
function lpos(m, i, v) { var a = m.instanceMatrix.array, o = i * 16; return v.set(a[o + 12], a[o + 13], a[o + 14]); }

/* ---- zones: a tooth for grillz, a part of the watch ---- */
function teeth() {
var out = [];
if (S) S.traverse(function (o) { if (o.userData && o.userData.capped === true) out.push(o); });
return out.map(function (n) {
var i = n.parent ? n.parent.children.indexOf(n) : 0, up = n.position.y > 0;
return { p: n.position, name: up ? "Upper #" + (4 + i) : "Lower #" + (29 - i) };
});
}
var _v = new THREE.Vector3();
function zoneOf(m, i, T) {
lpos(m, i, _v);
if (GRILLZ) {
var best = "", bd = 1e9;
(T || teeth()).forEach(function (t) { var d = _v.distanceToSquared(t.p); if (d < bd) { bd = d; best = t.name; } });
return best;
}
var ax = Math.abs(_v.x), ay = Math.abs(_v.y), z = _v.z, a = m.instanceMatrix.array, o = i * 16;
var uz = a[o + 6] / (Math.hypot(a[o + 4], a[o + 5], a[o + 6]) || 1);
if (ay > 26.8 || z < -8) return "Bracelet";
if (uz < 0.5) return ax > 20.6 ? "Case sides" : Math.max(ax, ay) < 18.5 ? "Bezel" : "Bracelet";
if (z > 3) return "Bezel";
if (z < 1.15 && ay > 17) return "Lugs";
if (ax <= 13.3 && ay <= 13.3) return "Dial";
return "Case top";
}

/* ---- painting on the canvas ---- */
var painting = false, tool = "stone", size = 2, stroke = null;
var _w = new THREE.Vector3(), _e = new THREE.Vector3();
function hits(ev) {
if (!C || !live().length) return [];
var rc = cvs.getBoundingClientRect(), px = ev.clientX - rc.left, py = ev.clientY - rc.top;
var rad = tool === "brush" ? [0, 10, 18, 30, 46, 70][size] : 14, cand = [];
C.updateMatrixWorld(); _e.setFromMatrixPosition(C.matrixWorld);
meshes.forEach(function (m) {
m.updateMatrixWorld();
for (var i = 0; i < m.count; i++) {
lpos(m, i, _w).applyMatrix4(m.matrixWorld);
var d = _w.distanceTo(_e); _w.project(C);
var sx = (_w.x + 1) / 2 * rc.width - px, sy = (1 - _w.y) / 2 * rc.height - py, q = sx * sx + sy * sy;
if (q <= rad * rad) cand.push({ m: m, i: i, d: d, q: q });
}
});
if (!cand.length) return [];
var d0 = Math.min.apply(null, cand.map(function (c) { return c.d; })), tol = tool === "brush" ? 4 : 1.6;
cand = cand.filter(function (c) { return c.d <= d0 + tol; });
if (tool !== "brush") { cand.sort(function (a, b) { return a.q - b.q; }); cand = cand.slice(0, 1); }
return cand;
}
function paintAt(ev) {
var hs = hits(ev), hex = isClear(brush) ? "#FFFFFF" : brush;
if (!hs.length) return;
if (tool === "zone") {
var z = zoneOf(hs[0].m, hs[0].i), T = GRILLZ ? teeth() : null;
live().forEach(function (m) { for (var i = 0; i < m.count; i++) if (zoneOf(m, i, T) === z) m.__ffp[i] = hex; repaint(m); });
return;
}
var touched = [];
hs.forEach(function (h) { h.m.__ffp[h.i] = hex; if (touched.indexOf(h.m) < 0) touched.push(h.m); });
touched.forEach(repaint);
}
function onCanvas(e) { return painting && (e.target === cvs); }
window.addEventListener("pointerdown", function (e) { if (!onCanvas(e)) return; e.stopPropagation(); e.preventDefault(); stroke = true; paintAt(e); }, true);
window.addEventListener("pointermove", function (e) { if (!stroke || !painting) return; e.stopPropagation(); if (tool !== "zone") paintAt(e); }, true);
window.addEventListener("pointerup", function () { stroke = null; }, true);

/* ---- summary for the order and the report ---- */
function summary() {
var by = {}, T = GRILLZ ? teeth() : null, total = 0;
live().forEach(function (m) {
for (var i = 0; i < m.count; i++) {
var hx = m.__ffp[i] || base || "#FFFFFF"; if (isClear(hx)) hx = "#FFFFFF";
var z = zoneOf(m, i, T), e = by[hx] || (by[hx] = { hex: hx, name: shadeName(hx), count: 0, zones: {} });
e.count++; e.zones[z] = (e.zones[z] || 0) + 1; total++;
}
});
var zt = {};
Object.keys(by).forEach(function (k) { Object.keys(by[k].zones).forEach(function (z) { zt[z] = (zt[z] || 0) + by[k].zones[z]; }); });
var list = Object.keys(by).map(function (k) {
var e = by[k];
e.zoneText = Object.keys(e.zones).map(function (z) { return e.zones[z] === zt[z] ? z : z + " (part)"; }).join(", ");
return e;
}).sort(function (a, b) { return b.count - a.count; });
return { list: list, total: total };
}
function painted() { return live().some(function (m) { return m.__ffp.some(Boolean); }) || (base && !isClear(base)); }
function orderText() {
if (!painted()) return "";
return summary().list.map(function (e) { return e.name + (e.name === "Clear" ? "" : " " + e.hex) + " x" + e.count + " [" + e.zoneText + "]"; }).join("; ").slice(0, 900);
}
var ATTR = /&attributes\[Stone%20colours?\]=[^&]*/g;
function fixHref() {
var h = cta.getAttribute("href") || "#";
if (h === "#" || h.indexOf("/cart/") < 0) return;
var t = orderText(), add = t ? "&attributes[Stone%20colours]=" + encodeURIComponent(t) : "", cur = h.match(ATTR) || [];
if (cur.length === (add ? 1 : 0) && (!add || cur[0] === add)) return;
cta.setAttribute("href", h.replace(ATTR, "") + add);
}
if (window.MutationObserver) new MutationObserver(fixHref).observe(cta, { attributes: true, attributeFilter: ["href"] });
cta.addEventListener("click", fixHref, true);
var tmr = 0;
function changed() { clearTimeout(tmr); tmr = setTimeout(function () { fixHref(); if (window.FFPaint && FFPaint.onChange) FFPaint.onChange(); }, 120); }

/* ---- panel ---- */
var css = document.createElement("style");
css.textContent =
".s-wheelwrap{display:flex;gap:14px;align-items:center;flex-wrap:wrap}" +
".s-wheel{width:132px;height:132px;border-radius:50%;cursor:crosshair;touch-action:none;flex:none;box-shadow:0 0 0 1px var(--line,#2a2f3a)}" +
".s-wheelside{flex:1 1 140px;min-width:0;display:grid;gap:9px}" +
".s-picks{display:grid;grid-template-columns:repeat(4,1fr);gap:6px}" +
".s-pick{height:26px;border-radius:7px;border:1px solid rgba(255,255,255,.22);cursor:pointer;padding:0}" +
".s-pick[aria-pressed=true]{outline:2px solid var(--gold,#E9C46A);outline-offset:2px}" +
".s-shade{width:100%;accent-color:var(--gold,#E9C46A)}" +
".s-stonename{font-size:12.5px;color:var(--muted,#9aa3b2);display:flex;align-items:center;gap:8px}" +
".s-stonename i{width:16px;height:16px;border-radius:50%;border:1px solid rgba(255,255,255,.3);flex:none}" +
".s-ptools{display:flex;flex-wrap:wrap;gap:6px;margin-top:12px}" +
".s-ptools button{flex:1 1 auto;min-height:36px;padding:6px 10px;border-radius:9px;border:1px solid var(--line2,#3a3f4a);background:transparent;color:inherit;font:inherit;font-size:13px;cursor:pointer}" +
".s-ptools button[aria-pressed=true]{border-color:var(--gold,#E9C46A);background:rgba(233,196,106,.14)}" +
".s-prow{display:none;gap:10px;align-items:center;margin-top:10px;font-size:12.5px;color:var(--muted,#9aa3b2)}" +
".s-painting .s-prow{display:flex}.s-painting #gl{cursor:crosshair}";
document.head.appendChild(css);
var after = anchor.closest ? anchor.closest(".s-grp") : null;
if (!after) return;
var grp = document.createElement("div"); grp.className = "s-grp"; grp.id = "stoneWheel";
grp.innerHTML = '<h2>Stone colour</h2><div class="s-wheelwrap"><canvas class="s-wheel" width="264" height="264" aria-label="Stone colour wheel"></canvas>' +
'<div class="s-wheelside"><div class="s-picks"></div><label class="s-stonename" style="display:block">Brightness<input class="s-shade" type="range" min="15" max="100" value="100"></label>' +
'<div class="s-stonename"><i></i><span></span></div></div></div>' +
'<div class="s-ptools"><button type="button" data-a="paint" aria-pressed="false">Paint stones</button><button type="button" data-a="fill">Fill all</button><button type="button" data-a="reset">Reset to clear</button></div>' +
'<div class="s-prow s-ptools" style="margin-top:8px"><button type="button" data-t="stone" aria-pressed="true">One stone</button><button type="button" data-t="brush" aria-pressed="false">Brush</button><button type="button" data-t="zone" aria-pressed="false">' + (GRILLZ ? "Whole tooth" : "Whole part") + '</button></div>' +
'<label class="s-prow">Brush size<input class="s-bsize" type="range" min="1" max="5" value="2" style="flex:1;accent-color:var(--gold,#E9C46A)"></label>' +
'<p class="s-blurb s-phint">Pick a shade, then Fill all, or turn on Paint stones and tap or drag across the piece. Turn painting off to spin it again.</p>';
after.parentNode.insertBefore(grp, after.nextSibling);
var cv = grp.querySelector("canvas"), cx = cv.getContext("2d"), RW = 132, img = cx.createImageData(264, 264);
for (var y = 0; y < 264; y++) for (var x = 0; x < 264; x++) {
var dx = x - RW, dy = y - RW, d = Math.sqrt(dx * dx + dy * dy), o = (y * 264 + x) * 4;
if (d > RW) continue;
var hx = hsvHex((Math.atan2(dy, dx) * 180 / Math.PI + 360) % 360, Math.min(1, d / RW), 1);
img.data[o] = parseInt(hx.substr(1, 2), 16); img.data[o + 1] = parseInt(hx.substr(3, 2), 16); img.data[o + 2] = parseInt(hx.substr(5, 2), 16); img.data[o + 3] = 255;
}
var hue = 0, sat = 0, val = 1, slider = grp.querySelector(".s-shade"), sw = grp.querySelector(".s-stonename i"), nm = grp.querySelector(".s-stonename span");
function paint() {
cx.clearRect(0, 0, 264, 264); cx.putImageData(img, 0, 0);
var a = hue * Math.PI / 180, mx = RW + Math.cos(a) * sat * RW * 0.94, my = RW + Math.sin(a) * sat * RW * 0.94;
cx.lineWidth = 4; cx.strokeStyle = "#000"; cx.beginPath(); cx.arc(mx, my, 10, 0, Math.PI * 2); cx.stroke();
cx.lineWidth = 2; cx.strokeStyle = "#fff"; cx.stroke();
sw.style.background = brush; nm.textContent = (painting ? "Brush: " : "") + (isClear(brush) ? "Clear (colourless)" : shadeName(brush) + " (" + brush + ")");
[].forEach.call(grp.querySelectorAll(".s-pick"), function (b) { b.setAttribute("aria-pressed", b.dataset.hex === brush ? "true" : "false"); });
}
function fillAll() { base = isClear(brush) ? null : brush; live().forEach(function (m) { m.__ffp = new Array(m.count); }); repaintAll(); }
function commit(exact) { brush = exact || hsvHex(hue, sat, val); if (isClear(brush)) brush = "#FFFFFF"; emit(); if (!painting) fillAll(); }
var ui = [];
function emit() { paint(); [].forEach.call(grp.querySelectorAll("[data-t]"), function (x) { x.setAttribute("aria-pressed", x.dataset.t === tool ? "true" : "false"); });
grp.querySelector("[data-a=paint]").setAttribute("aria-pressed", painting ? "true" : "false"); ui.forEach(function (f) { f(); }); }
function setTool(t) { tool = t; emit(); }
function setSize(n) { size = n; grp.querySelector(".s-bsize").value = n; emit(); }
function setPainting(on) {
painting = !!on; document.body.classList.toggle("s-painting", painting);
var sp = document.getElementById("btnSpin");
if (painting && sp && sp.getAttribute("aria-pressed") === "true") sp.click();
emit();
}
function pickHex(hex) { var hsv = hexHsv(hex); hue = hsv[0]; sat = hsv[1]; val = hsv[2]; slider.value = Math.round(Math.max(0.15, val) * 100); commit(hex); }
function pick(e) {
var r = cv.getBoundingClientRect(), px = (e.clientX - r.left) / r.width * 264 - RW, py = (e.clientY - r.top) / r.height * 264 - RW;
hue = (Math.atan2(py, px) * 180 / Math.PI + 360) % 360; sat = Math.min(1, Math.sqrt(px * px + py * py) / RW); commit();
}
var down = false;
cv.addEventListener("pointerdown", function (e) { down = true; if (cv.setPointerCapture) { try { cv.setPointerCapture(e.pointerId); } catch (z) {} } pick(e); });
cv.addEventListener("pointermove", function (e) { if (down) pick(e); });
["pointerup", "pointercancel"].forEach(function (k) { cv.addEventListener(k, function () { down = false; }); });
slider.addEventListener("input", function () { val = slider.value / 100; commit(); });
grp.querySelector(".s-bsize").addEventListener("input", function () { setSize(+this.value); });
PICKS.forEach(function (p) {
var b = document.createElement("button"); b.type = "button"; b.className = "s-pick"; b.dataset.hex = p[0];
b.style.background = p[0]; b.title = p[1]; b.setAttribute("aria-label", p[1] + " stones");
b.addEventListener("click", function () { pickHex(p[0]); });
grp.querySelector(".s-picks").appendChild(b);
});
grp.addEventListener("click", function (e) {
var b = e.target.closest("button"); if (!b) return;
if (b.dataset.t) setTool(b.dataset.t);
var a = b.dataset.a;
if (a === "fill") fillAll();
if (a === "reset") { pickHex("#FFFFFF"); fillAll(); }
if (a === "paint") setPainting(!painting);
});
paint();

window.FFPaint = { kind: GRILLZ ? "grillz" : "watch", panel: grp, cta: cta, canvas: cvs,
gl: function () { return { renderer: R, scene: S, camera: C }; }, summary: summary, painted: painted, orderText: orderText, onChange: null,
picks: PICKS, ui: ui, setTool: setTool, setSize: setSize, setPainting: setPainting, pickHex: pickHex, fillAll: fillAll,
state: function () { return { painting: painting, tool: tool, size: size, brush: brush, radius: tool === "brush" ? [0, 10, 18, 30, 46, 70][size] : 14 }; } };
if (SELF) ["ff-stonereport.js", "ff-stonestage.js"].forEach(function (f) { var s2 = document.createElement("script"); s2.src = SELF.replace(/ff-stonewheel\.js[^\/]*$/, f + "?v=" + Math.floor(Date.now() / 6e5)); s2.async = true; document.body.appendChild(s2); });
})();